import type { ButtonProps } from "antd";

import { InfoCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

export const InfoButton = ({ children, ...buttonProps }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button icon={<InfoCircleOutlined />} {...buttonProps}>
      {children ?? t("global:info")}
    </Button>
  );
};
